import { createApp } from 'vue';
import App from './App.vue';
import store from './store';

window.addEventListener('DOMContentLoaded', () => {
  createApp(App).use(store).mount('#vue-locations');
});
